import {NotificationsSettingsService} from "../services/notificationsSettingsService";
import Vue from 'vue'

const state = {
  staffSettings: {},
  staffSettingsForDiscard: {},
  isSuccessfullySaved:false,
  usedApps: []
}

const getters = {
  staffSettings: state => state.staffSettings,
  isSuccessfullySaved: state => state.isSuccessfullySaved,
  allStaffSettingsArray: state => {
    const settingsCategoriesKeys = Object.keys(state.staffSettings)
    if(settingsCategoriesKeys.length > 0){
      const concatedArray = settingsCategoriesKeys.map(category =>{
        return state.staffSettings[category]
      }).reduce((previousValue,currentValue) => previousValue.concat(currentValue))
      return concatedArray
    }
  },
  usedApps: state => state.usedApps,
  changedSettingsAmount: (state, getters) => {
    if (getters.allStaffSettingsArray){
      const changedSettings = getters.allStaffSettingsArray.filter(setting =>
        (setting.changed?.push || setting.changed?.pane || setting.changed?.email || setting.changed?.sms))
      return changedSettings.length
    }
    return 0;
  }
}

const mutations = {
  setStaffSettings(state, staffSettings) {
    state.staffSettings = staffSettings
    state.staffSettingsForDiscard = JSON.parse(JSON.stringify(staffSettings))
  },
  setIsSuccessfullySaved(state, value){
    state.isSuccessfullySaved = value
  },
  setChangedSetting(state, changedItem){
    Object.keys(state.staffSettings).every(category =>{
      const index = state.staffSettings[category].findIndex(currentSetting =>
        currentSetting.notification_metadata_uid === changedItem.notification_metadata_uid)
      if(index > -1) {
        Vue.set(state.staffSettings[category], index,{
          ...state.staffSettings[category][index],
          ...changedItem,
        })
        return false;
      }
      return true
    })
  },
  setUsedApps(state, usedApps){
    state.usedApps = usedApps
  },
  resetStaffSettings(state){
    state.staffSettings = {}
  },
  discardChanges(state){
    state.staffSettings = state.staffSettingsForDiscard
    state.staffSettingsForDiscard = JSON.parse(JSON.stringify(state.staffSettingsForDiscard))
  }
}

const actions = {
  async fetchUsedApps({commit, rootGetters, state, dispatch}){
    if(state.usedApps.length === 0){
      await dispatch("appMarketModule/loadApps", {} , {root: true})
      let usablityStatusCheck = rootGetters["appMarketModule/appUsabilityStatus"]
      let apps = rootGetters["appMarketModule/apps"]
      const usedApps = apps.filter(app => usablityStatusCheck(app))
      commit('setUsedApps', usedApps)
    }
  },
  async fetchStaffSettings({commit, rootGetters, state}){
    let staff = rootGetters["accountModule/staff"]
    let profile = rootGetters["accountModule/profile"]
    let locale = profile.business.locale
    const mappedSettings = await NotificationsSettingsService.composeSettingsData(staff.uid, state.usedApps, locale)

    if(rootGetters.hasFeature('disable_messages_notifications')) {
      if(mappedSettings.messages) {
        mappedSettings.messages = mappedSettings.messages.filter(massage => massage.category !== "client");
      }
    }
    commit('setStaffSettings', mappedSettings)
  },
  async updateChangedSetting({commit}, payload){
    commit('setChangedSetting', payload)
  },
  async saveSettingsChanges({commit, getters, dispatch}){
    try{
      const isSomethingChange = changed => changed?.push || changed?.pane || changed?.email || changed?.sms;
      const settingsToCreate = await getters.allStaffSettingsArray.filter(setting => !setting.uid && isSomethingChange(setting.changed))
      const settingsToUpdate = await getters.allStaffSettingsArray.filter(setting => setting.uid && isSomethingChange(setting.changed))

      // create
      const createMap = settingsToCreate.map(currentSetting =>  NotificationsSettingsService.createSingleSetting(currentSetting))
      // update
      const updateMap = settingsToUpdate.map( currentSetting => NotificationsSettingsService.updateSingleSetting(currentSetting))

      await Promise.all(createMap.concat(updateMap)).then(returnedValues =>{
        const isSuccessfullySaved = returnedValues.filter(value => value === undefined).length === 0
        commit('setIsSuccessfullySaved', isSuccessfullySaved)
      })
      await dispatch('fetchStaffSettings')
    }
    catch (e){
      console.log(e)
    }
  },
  async resetStaffSettings({commit}){
    commit('resetStaffSettings')
  },
  async discardChanges({commit}){
    commit('discardChanges')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
